import { codenameSlots } from '@/game/codename';
import { cx } from '@/lib/cx';
import { Sparkles } from './Sparkles';
import { Surface } from './Surface';
import styles from './CodenameTiles.module.css';

interface CodenameTilesProps {
  codename: string;
  revealedCount: number;
  /** Letter index to spotlight, usually the one just revealed. */
  highlight?: number | undefined;
  className?: string;
}

/**
 * A foe's codename on a bolted plate; hidden letters show as blanks. A long codename wraps
 * between words, never inside one.
 */
export function CodenameTiles({
  codename,
  revealedCount,
  highlight,
  className,
}: CodenameTilesProps) {
  const slots = codenameSlots(codename, revealedCount);
  const hidden = slots.filter((s) => s.kind === 'letter' && !s.revealed).length;
  const words: (typeof slots)[] = [[]];
  for (const slot of slots) {
    if (slot.kind === 'gap') words.push([]);
    else words[words.length - 1]?.push(slot);
  }

  return (
    <Surface
      variant="plate"
      className={cx(styles.plate, className)}
      role="img"
      aria-label={
        hidden === 0 ? codename : `${codename.slice(0, 0)}Codename, ${hidden} letters still hidden`
      }
    >
      {words.map((word, w) => (
        <span key={w} className={styles.word}>
          {word.map((slot) =>
            slot.kind === 'gap' ? null : (
              <span
                key={slot.letterIndex}
                className={cx(
                  styles.tile,
                  !slot.revealed && styles.hidden,
                  slot.letterIndex === highlight && styles.highlight,
                )}
              >
                {slot.revealed ? slot.char : ''}
                {slot.letterIndex === highlight && <Sparkles />}
              </span>
            ),
          )}
        </span>
      ))}
    </Surface>
  );
}
